import React, { useEffect, useRef } from "react";
import "./LoadingScreen.css";

const NUM_LINES = 8;

function LoadingScreen({ onFinish }) {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    const logo = new Image();
    logo.src = process.env.PUBLIC_URL + "/assets/resimler/LoadingLogo.png";

    const logoX = 60; 
    const logoY = canvas.height - 60;
    const logoRadius = 40;

    const lines = [];
    const startAngle = Math.PI / 6; // 30°
    const endAngle = Math.PI / 3;   // 60°
    const angleStep = (endAngle - startAngle) / (NUM_LINES - 1)*2;

    for (let i = 0; i < NUM_LINES; i++) {
      const angle = startAngle + i * angleStep;
      lines.push({
        x: logoX + logoRadius,
        y: logoY,
        angle,
        speed: 15,
        length: 1200,
      });
    }

    let animationId;
    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      
      ctx.drawImage(
        logo,
        logoX - logoRadius,
        logoY - logoRadius,
        logoRadius * 2,
        logoRadius * 2
      );

      let allFinished = true;

      lines.forEach((line) => {
        const dx = Math.cos(line.angle) * line.speed;
        const dy = -Math.sin(line.angle) * line.speed;

        line.x += dx;
        line.y += dy;

        ctx.strokeStyle = "#fff";
        ctx.lineWidth = 2;
        ctx.beginPath();
        ctx.moveTo(line.x, line.y);
        ctx.lineTo(line.x - dx * line.length / line.speed, line.y - dy * line.length / line.speed);
        ctx.stroke();

        if (line.x < canvas.width && line.y > 0) {
          allFinished = false;
        }
      });

      if (!allFinished) {
        animationId = requestAnimationFrame(animate);
      } else {
        onFinish && onFinish();
      }
    };

    logo.onload = () => {
      animate();
    };

    return () => cancelAnimationFrame(animationId);
  }, [onFinish]);

  return <canvas ref={canvasRef} className="loader-canvas" />;
}

export default LoadingScreen;
